export {
  default,
}
  from './retailer.vue'
